import { render, staticRenderFns } from "./settingSupplierIcon.vue?vue&type=template&id=548ccf19&scoped=true"
import script from "./settingSupplierIcon.vue?vue&type=script&lang=js"
export * from "./settingSupplierIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548ccf19",
  null
  
)

export default component.exports